import axios from "axios";
const log = (data, event, type = "log", role) => {
  console.log("loggin", event);
  let localStorageName = window.localStorage.getItem("name");
  if (localStorageName) {
    localStorageName = localStorageName
      .replace(/[^a-z0-9]/gi, "_")
      .toLowerCase();
  } else {
    localStorageName = "guest";
  }

  axios
    .post(`/api/log`, {
      data,
      message: data?.error?.target?.error?.message,
      event,
      type,
      url: window.location.pathname,
      ua: navigator.userAgent,
      name: localStorageName,
      role,
    })
    .then(console.log("success logging"))
    .catch(console.log);
};
export default log;
